import { Form, Row, FormInstance, Col, FormItemProps, Input, InputNumber, Space, Typography } from "antd";
import Configuracao from "../../../../../../Models/Financeiro/Conta/Remessa/Configuracao";
import { NamePath } from "antd/lib/form/interface";
import EspecieSelect from "../Especie/EspecieSelect";
import { useEffect } from "react";
import React from "react";

export interface IConfiguracaoFormBasic<T> extends FormItemProps<T> {//extends FormItemProps<Configuracao> {

}
export default function ConfiguracaoFormBasic<T>({
    initialValue,
    name,
    ...props
}:IConfiguracaoFormBasic<T>) {
    return <React.Fragment>
        <Row gutter={16}>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "codEspecie"]} initialValue={initialValue?.codEspecie} label={"Espécie"}>
                    <EspecieSelect />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "codigoCedente"]} initialValue={initialValue?.codigoCedente} label={"Código cedente"}>
                    <Input 
                        placeholder="Código cedente"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "codigoCedenteDac"]} initialValue={initialValue?.codigoCedenteDac} label={"Dac Cedente"}>
                    <Input 
                        placeholder="Dac Cedente"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "carteira"]} initialValue={initialValue?.carteira} label={"Carteira"}>
                    <InputNumber 
                        style={{ width: "100%" }} 
                        precision={0} 
                        controls={false}
                        placeholder="Carteira"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "carteiraVariacao"]} initialValue={initialValue?.carteiraVariacao} label={"Var. Carteira"}>
                    <InputNumber 
                        style={{ width: "100%" }} 
                        precision={0} 
                        controls={false}
                        placeholder="Variação carteira"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "layoutCnab"]} initialValue={initialValue?.layoutCnab} label={"CNAB"}>
                    <InputNumber 
                        addonBefore={<>Nº</>} 
                        style={{ width: "100%" }} 
                        min={100} 
                        max={400}
                        precision={0} 
                        controls={false}
                        placeholder="Informe o cnab"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "diasProtesto"]} initialValue={initialValue?.diasProtesto} label={"Protestar em"}>
                    <InputNumber 
                        addonAfter={<>dias</>} 
                        style={{ width: "100%" }} 
                        min={0} 
                        max={100}
                        precision={0} 
                        controls={false}
                        placeholder="Dias para protesto"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "multa"]} initialValue={initialValue?.multa} label={"Multa"}>
                    <InputNumber
                        addonAfter={<>%</>} 
                        style={{ width: "100%" }} 
                        min={0.00} 
                        max={100.00}
                        precision={2} 
                        controls={false}
                        placeholder="Multa"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "juros"]} initialValue={initialValue?.juros} label={"Juros"}>
                    <InputNumber 
                        addonAfter={<>% ao dia</>} 
                        style={{ width: "100%" }} 
                        min={0.00} 
                        max={100.00}
                        precision={2} 
                        controls={false}
                        placeholder="Juros"
                    />
                </Form.Item>
            </Col>
            
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "ultimoNumeroArquvoRemessa"]} initialValue={initialValue?.ultimoNumeroArquvoRemessa} label={"Último número arquivo"}>
                    <InputNumber 
                        addonBefore={<>Nº</>} 
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={0}
                        controls={false}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<T> name={[name, "ultimoNumeroTitulo"]} initialValue={initialValue?.ultimoNumeroTitulo} label={"Último número titulo"}>
                    <InputNumber
                        addonBefore={<>Nº</>}
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={0}
                        controls={false}
                    />
                </Form.Item>
            </Col>
        </Row>

        <Row gutter={[16, 16]}>
            <Col xs={24} sm={8} style={{display: "flex", flexDirection: "column", gap: ".5em"}}>
                <Typography.Text style={{textAlign: "center"}}> Instrução 01 </Typography.Text>

                <Space.Compact block>
                    <Form.Item<T> style={{flex: 1, marginBottom: 0}} name={[name, "codigoInstrucao1"]} initialValue={initialValue?.codigoInstrucao1}>
                        <InputNumber
                            style={{ width: "100%" }} 
                            min={0.00} 
                            precision={0}
                            controls={false}
                            placeholder="Código"
                        />
                    </Form.Item>

                    <Form.Item<T> style={{flex: 3, marginBottom: 0}} name={[name, "instrucao1"]} rules={[{ max : 25 }]} initialValue={initialValue?.codigoInstrucao1}>
                        <Input placeholder="Descrição" />
                    </Form.Item>
                </Space.Compact>
            </Col>

            <Col xs={24} sm={8} style={{display: "flex", flexDirection: "column", gap: ".5em"}}>
                <Typography.Text style={{textAlign: "center"}}> Instrução 02 </Typography.Text>
                <Space.Compact block>
                    <Form.Item<T> style={{flex: 1, marginBottom: 0}} name={[name, "codigoInstrucao2"]} initialValue={initialValue?.codigoInstrucao2}>
                        <InputNumber
                            style={{ width: "100%" }} 
                            min={0.00} 
                            precision={0}
                            controls={false}
                            placeholder="Código"
                        />
                    </Form.Item>

                    <Form.Item<T> style={{flex: 3, marginBottom: 0}} name={[name, "instrucao2"]} rules={[{ max : 25 }]} initialValue={initialValue?.codigoInstrucao2}>
                        <Input placeholder="Descrição" />
                    </Form.Item>
                </Space.Compact>
            </Col>

            <Col xs={24} sm={8} style={{display: "flex", flexDirection: "column", gap: ".5em"}}>
                <Typography.Text style={{textAlign: "center"}}> Instrução 03 </Typography.Text>
                <Space.Compact block>
                    <Form.Item<T> style={{flex: 1, marginBottom: 0}} name={[name, "codigoInstrucao3"]} initialValue={initialValue?.codigoInstrucao3}>
                        <InputNumber
                            style={{ width: "100%" }} 
                            min={0.00} 
                            precision={0}
                            controls={false}
                            placeholder="Código"
                        />
                    </Form.Item>

                    <Form.Item<T> style={{flex: 3, marginBottom: 0}} name={[name, "instrucao3"]} rules={[{ max : 25 }]} initialValue={initialValue?.codigoInstrucao3} >
                        <Input placeholder="Descrição" />
                    </Form.Item>
                </Space.Compact>
            </Col>

        </Row>

    </React.Fragment>
    
}